import { render, staticRenderFns } from "./OTServiceTechForm.vue?vue&type=template&id=8b9ebd90&lang=pug"
import script from "./OTServiceTechForm.vue?vue&type=script&lang=js"
export * from "./OTServiceTechForm.vue?vue&type=script&lang=js"
import style0 from "./OTServiceTechForm.vue?vue&type=style&index=0&id=8b9ebd90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports